import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "matched", label: "Matched" },
  { key: "unmatched", label: "Unmatched" },
];

function timeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  return `${days}d`;
}

export default function ThreadList({
  threads,
  selectedId,
  onSelect,
  filter,
  onFilterChange,
  search,
  onSearchChange,
}) {
  return (
    <div className="cinbox-list">
      <div className="cinbox-list-search">
        <SearchIcon />
        <input
          type="text"
          placeholder="Search by name or email…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="cinbox-list-filters">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            className={`cinbox-filter-btn${filter === f.key ? " active" : ""}`}
            onClick={() => onFilterChange(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="cinbox-list-scroll">
        {threads.length === 0 ? (
          <div className="stripe-empty">
            <div className="stripe-empty-icon">📭</div>
            No conversations found
          </div>
        ) : (
          threads.map((t) => {
            const isSelected = t._id === selectedId;
            return (
              <button
                key={t._id}
                className={`cinbox-thread-row${isSelected ? " selected" : ""}${t.unreadCount > 0 ? " unread" : ""}`}
                onClick={() => onSelect(t._id)}
              >
                <div className="cinbox-thread-row-top">
                  <span className="cinbox-thread-name">{t.contactName || t.contactEmail}</span>
                  <span className="cinbox-thread-time">{t.lastMessageAt ? timeAgo(t.lastMessageAt) : ""}</span>
                </div>
                <div className="cinbox-thread-email">{t.contactEmail}</div>
                <div className="cinbox-thread-snippet">
                  {t.lastMessageDirection === "outbound" && <span className="cinbox-you-prefix">You: </span>}
                  {t.lastMessageSnippet}
                </div>
                <div className="cinbox-thread-badges">
                  {t.isMatched ? (
                    <span className="stripe-badge cinbox-badge-matched">
                      <CheckCircleIcon /> Matched
                    </span>
                  ) : (
                    <span className="stripe-badge cinbox-badge-unmatched">
                      <HelpOutlineIcon /> {t.candidateCrmIds?.length ? "Possible match" : "Unmatched"}
                    </span>
                  )}
                  {t.campaignLabel && (
                    <span className="p_chip cinbox-campaign-chip">
                      <LocalOfferOutlinedIcon /> {t.campaignLabel.campaignName}
                    </span>
                  )}
                  {t.unreadCount > 0 && <span className="cinbox-unread-dot" />}
                </div>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
